var _circle, _circle2, _circle3, _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "url(#paint0_linear_3333_19701)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F4F1EB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 13,
    r: 5,
    fill: "#E81530"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.8711,
    y: 12.1936,
    width: 2.25806,
    height: 4.51613,
    rx: 1.12903,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8711,
    y: 9.29028,
    width: 2.25806,
    height: 2.25806,
    rx: 1.12903,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3333_19701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6919 18.7344C22.0007 18.7344 18.1841 22.551 18.1841 27.2422C18.1841 31.9334 22.0007 35.75 26.6919 35.75C31.3831 35.75 35.1997 31.9334 35.1997 27.2422C35.1997 22.551 31.3831 18.7344 26.6919 18.7344ZM26.6919 26.4688C27.9714 26.4688 29.0122 27.5096 29.0122 28.7891C29.0122 29.7961 28.3637 30.6466 27.4653 30.9669V32.6562H25.9185V30.9669C25.0201 30.6466 24.3716 29.7961 24.3716 28.7891H25.9185C25.9185 29.2158 26.2652 29.5625 26.6919 29.5625C27.1186 29.5625 27.4653 29.2158 27.4653 28.7891C27.4653 28.3623 27.1186 28.0156 26.6919 28.0156C25.4124 28.0156 24.3716 26.9748 24.3716 25.6953C24.3716 24.6883 25.0201 23.8378 25.9185 23.5175V21.8281H27.4653V23.5175C28.3637 23.8378 29.0122 24.6883 29.0122 25.6953H27.4653C27.4653 25.2686 27.1186 24.9219 26.6919 24.9219C26.2652 24.9219 25.9185 25.2686 25.9185 25.6953C25.9185 26.122 26.2652 26.4688 26.6919 26.4688Z",
    fill: "url(#paint1_linear_3333_19701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4107 18.7345C22.1813 18.7345 25.9186 16.6959 25.9186 14.0938C25.9186 11.4918 22.1813 9.3501 17.4107 9.3501C12.6402 9.3501 8.7998 11.4918 8.7998 14.0938C8.7998 16.6959 12.6402 18.7345 17.4107 18.7345Z",
    fill: "url(#paint2_linear_3333_19701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7998 26.7554V28.0156C8.7998 30.6177 12.6402 32.6562 17.4107 32.6562C17.6813 32.6562 17.9435 32.6313 18.21 32.6183C17.6167 31.6855 17.1742 30.6504 16.9137 29.5439C13.4639 29.4486 10.4685 28.3886 8.7998 26.7554Z",
    fill: "url(#paint3_linear_3333_19701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6745 27.9762C16.6567 27.7329 16.6373 27.4899 16.6373 27.2422C16.6373 26.4359 16.743 25.6555 16.9231 24.9037C13.469 24.8101 10.47 23.7494 8.7998 22.1147V23.375C8.7998 25.839 12.268 27.7754 16.6745 27.9762Z",
    fill: "url(#paint4_linear_3333_19701)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4107 23.375C17.4116 23.375 17.4122 23.3749 17.4131 23.3749C17.9232 22.1557 18.6647 21.0567 19.5856 20.1359C18.8871 20.2242 18.1652 20.2812 17.4107 20.2812C13.7386 20.2812 10.5491 19.1862 8.7998 17.4741V18.7344C8.7998 21.3364 12.6402 23.375 17.4107 23.375Z",
    fill: "url(#paint5_linear_3333_19701)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3333_19701",
    x1: 22,
    y1: 44,
    x2: 22,
    y2: 0.00000547192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3333_19701",
    x1: 18.1841,
    y1: 27.2422,
    x2: 35.1997,
    y2: 27.2422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3333_19701",
    x1: 8.7998,
    y1: 14.0423,
    x2: 25.9186,
    y2: 14.0423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3333_19701",
    x1: 8.7998,
    y1: 29.7058,
    x2: 18.21,
    y2: 29.7058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3333_19701",
    x1: 8.7998,
    y1: 25.0455,
    x2: 16.9231,
    y2: 25.0455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3333_19701",
    x1: 8.7998,
    y1: 20.4246,
    x2: 19.5856,
    y2: 20.4246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3333_19701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.4,
    height: 26.4,
    fill: "white",
    transform: "translate(8.7998 9.3501)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollect);
export default __webpack_public_path__ + "static/media/icon_collect.5054d893d4b9314c95208440bbcea762.svg";
export { ForwardRef as ReactComponent };